/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_CompletedInputs */

const en_spellcheck_completed = /** @type {(inputs: Spellcheck_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spell check process completed successfully`)
};

const fr_spellcheck_completed = /** @type {(inputs: Spellcheck_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification orthographique terminee avec succes`)
};

const de_spellcheck_completed = /** @type {(inputs: Spellcheck_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtschreibprüfung erfolgreich abgeschlossen`)
};

const it_spellcheck_completed = /** @type {(inputs: Spellcheck_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processo di controllo ortografico completato con successo`)
};

const ru_spellcheck_completed = /** @type {(inputs: Spellcheck_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Процесс проверки орфографии успешно завершен.`)
};

const es_spellcheck_completed = /** @type {(inputs: Spellcheck_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El proceso de revisión ortográfica se completó correctamente`)
};

const zh_cn2_spellcheck_completed = /** @type {(inputs: Spellcheck_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拼写检查过程已成功完成。`)
};

const ja_spellcheck_completed = /** @type {(inputs: Spellcheck_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペルチェックプロセスが正常に完了しました`)
};

const hi_spellcheck_completed = /** @type {(inputs: Spellcheck_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तनी जाँच प्रक्रिया सफलतापूर्वक पूरी हो गई`)
};

const pt_pt2_spellcheck_completed = /** @type {(inputs: Spellcheck_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A verificação ortográfica foi concluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Spell check process completed successfully" |
*
* @param {Spellcheck_CompletedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_completed = /** @type {((inputs?: Spellcheck_CompletedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_CompletedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_completed(inputs)
	if (locale === "de") return de_spellcheck_completed(inputs)
	if (locale === "it") return it_spellcheck_completed(inputs)
	if (locale === "ru") return ru_spellcheck_completed(inputs)
	if (locale === "es") return es_spellcheck_completed(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_completed(inputs)
	if (locale === "ja") return ja_spellcheck_completed(inputs)
	if (locale === "hi") return hi_spellcheck_completed(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_completed(inputs)
	return en_spellcheck_completed(inputs)
});